__turbopack_context__.v({
  "button": "anchor-module-scss-module__RAQ20W__button" + " " + __turbopack_context__.i(693367)["core"],
  "complete": "anchor-module-scss-module__RAQ20W__complete" + " " + __turbopack_context__.i(693367)["complete"],
  "medium": "anchor-module-scss-module__RAQ20W__medium",
  "playing": "anchor-module-scss-module__RAQ20W__playing" + " " + __turbopack_context__.i(693367)["playing"],
  "small": "anchor-module-scss-module__RAQ20W__small",
});
